import React, { Component } from 'react'

// libs
import cx from 'classnames'
// components
import NavBarLayout from 'components/layouts/NavBarLayout'
import MobileMenu from 'components/svgComponent/Menu'
import { OldButton } from 'components/Button'

// types
import { Classes } from 'jss'
import { ButtonTypes, ComposeType } from 'types/common'

// styles
import injectSheet from 'react-jss'
import { sheet } from './sheet'
import SmallLogoMenu from 'components/svgComponent/SmallLogoMenu'
import HeaderNavLink from 'pages/Layout/Header/HeaderNavLink'
// redux
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Push, push } from 'connected-react-router'

interface Props {
  classes: Classes
  push?: Push
}
interface ExternalProps {
  classes: Classes
  push?: Push
}

interface State {
  showMenu: boolean
}

const linksName = [
  { name: 'About Us', to: '/#about' },
  { name: 'Search jobs', to: '/find-jobs/new' },
  { name: 'Support', to: '/#support' },
  { name: 'FAQ', to: '/#faq' },
  { name: 'Contact information', to: '/#contacts' }
]

class NavBar extends Component<Props, State> {
  state = {
    showMenu: false
  }

  showHideMenu = () => {
    this.setState(prevState => ({ showMenu: !prevState.showMenu }))
  }

  getStickyOffset = () => {
    const bar = document.querySelector(`.${this.props.classes.stickyInner}`) as HTMLElement | null
    return (bar && bar.offsetHeight) || 0
  }

  getScrollParent = (node: HTMLElement | null): HTMLElement => {
    const docScroller = document.scrollingElement || document.documentElement
    if (!node) return docScroller as HTMLElement

    const isScrollable = (el: Element) => {
      const style = window.getComputedStyle(el as Element)
      const oy = style.overflowY
      return (
        /(auto|scroll|overlay)/.test(oy as string) &&
        (el as HTMLElement).scrollHeight > (el as HTMLElement).clientHeight
      )
    }

    let p: HTMLElement | null = node.parentElement
    while (p && p !== document.body) {
      if (isScrollable(p)) return p
      p = p.parentElement
    }
    return docScroller as HTMLElement
  }

  scrollToHash = (to: string) => {
    const hashIndex = to.indexOf('#')
    if (hashIndex === -1) return
    const id = to.slice(hashIndex + 1)
    const target = document.getElementById(id)
    if (!target) return

    const scroller = this.getScrollParent(target)
    const offset = this.getStickyOffset()

    // координаты target относительно scroller'а
    const targetRect = target.getBoundingClientRect()
    const scrollerRect = scroller.getBoundingClientRect()
    const currentScrollTop =
      scroller === document.scrollingElement || scroller === document.documentElement
        ? window.scrollY
        : scroller.scrollTop

    const top = currentScrollTop + (targetRect.top - scrollerRect.top) - offset

    if (scroller === document.scrollingElement || scroller === document.documentElement) {
      window.scrollTo({ top, behavior: 'smooth' })
    } else {
      scroller.scrollTo({ top, behavior: 'smooth' as ScrollBehavior })
    }
  }

  onHashLinkClick = (e: any, to?: string) => {
    if (!to || to.indexOf('#') === -1) return
    e.preventDefault()

    if (this.props.push) this.props.push(to)
    else window.history.pushState(null, '', to)

    if (this.state.showMenu) this.setState({ showMenu: false })

    this.scrollToHash(to)
  }

  onClick = (path: string, isCandidate: boolean = false) => {
    if (this.props.push) {
      this.props.push({
        pathname: path,
        state: {
          isCandidate
        }
      })
    }
  }

  signUpWithParamTrue = () => {
    this.onClick('/sign-up', true)
  }

  logIn = () => {
    this.onClick('/log-in')
  }

  render() {
    const { classes } = this.props
    const { showMenu } = this.state

    return (
      <div className={cx(classes.stickyBar, { [classes.stickyBarOpen]: showMenu })}>
        <div className={classes.stickyInner}>
          <div className={classes.headerLogo}>
            <SmallLogoMenu width={52} height={52} />
            <span>Skilent</span>
          </div>
          <div className={classes.menuIcons}>
            <MobileMenu fill="#080910" onClick={this.showHideMenu} />
          </div>
          <nav className={cx(classes.headerNav, { showMenu })}>
            {linksName.map((item, i) => (
              <HeaderNavLink
                to={item.to}
                key={i}
                label={item.name}
                onClick={(e: any, to?: string) => this.onHashLinkClick(e, to)}
              />
            ))}
          </nav>
          <div className={classes.headerAuth}>
            <OldButton type={ButtonTypes.AuthOutlineRounded} label="log in" onClick={this.logIn} />
            <OldButton
              type={ButtonTypes.AuthRounded}
              label="sign up"
              onClick={this.signUpWithParamTrue}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default compose<ComposeType<Props>>(
  connect(
    null,
    {
      push
    }
  ),
  injectSheet(sheet)
)(NavBar)
